/**
 * Diagnostic subsystem toggles (owner request, Test 21): to isolate what — if
 * anything — costs FPS / adds lag, disable NavMe subsystems one at a time via a
 * URL query flag, then measure `fpsAvg` in the 🐞 export.
 *
 *   ?no=crumbs,arrow,pill,occluder,voice   → bare navigation (tracking only)
 *   ?no=arrow,pill,occluder,voice          → bare + crumbs
 *   ?no=occluder                           → everything except the scan occluder
 *   ?no=all                                → disable all of the above at once
 *
 * Default (no query) = everything ON, i.e. normal behaviour — zero regression
 * risk. The active set is echoed into the debug export + a session log line so
 * every walk records exactly which subsystems were live.
 */
export type DiagFeature = 'crumbs' | 'arrow' | 'pill' | 'occluder' | 'voice';

const disabled: Set<string> = (() => {
  try {
    const raw = new URLSearchParams(window.location.search).get('no') ?? '';
    return new Set(raw.split(',').map((s) => s.trim().toLowerCase()).filter(Boolean));
  } catch {
    return new Set<string>();
  }
})();

/** True when `feature` has been disabled for this session via ?no=. */
export function diagDisabled(feature: DiagFeature): boolean {
  return disabled.has('all') || disabled.has(feature);
}

/** The active disable set, for the debug export / log line (empty = all on). */
export function diagDisabledList(): string[] {
  return [...disabled];
}
